import axios from '@/plugins/axios';
import { logApiError } from '@/services/api.js';

const baseUrl = '/api/publication-requests';

export const createPublicationRequest = async ({
  listing_id,
  is_open_source,
  notes,
}) => {
  try {
    const response = await axios.post(baseUrl, {
      listing_id,
      is_open_source: is_open_source ?? undefined,
      notes: notes || undefined,
    });
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', baseUrl);
    throw error;
  }
};

export const getMyPublicationRequests = async () => {
  try {
    const response = await axios.get(`${baseUrl}/mine`);
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', `${baseUrl}/mine`);
    throw error;
  }
};

export const getPublicationRequests = async () => {
  try {
    const response = await axios.get(baseUrl);
    return response.data;
  } catch (error) {
    logApiError(error, 'GET', baseUrl);
    throw error;
  }
};

export const reviewPublicationRequest = async (id, status) => {
  try {
    const response = await axios.post(`${baseUrl}/${id}/review`, { status });
    return response.data;
  } catch (error) {
    logApiError(error, 'POST', `${baseUrl}/:id/review`);
    throw error;
  }
};
